export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_USER_FAILED = 'LOGIN_USER_FAILED';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILED = 'CHANGE_PASSWORD_FAILED';

export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILED = 'LOGOUT_USER_FAILED';

export const LOCK_SCREEN = 'LOCK_SCREEN';

export const ERROR_HANDLING_SERVICES = 'ERROR_HANDLING_SERVICES';

/* Markets action types */
export const GET_MARKET_DESCS_REQUEST = 'GET_MARKET_DESCS_REQUEST';
export const GET_MARKET_DESCS_SUCCESS = 'GET_MARKET_DESCS_SUCCESS';

export const GET_MAIN_MARKETS_REQUEST = 'GET_MAIN_MARKETS_REQUEST';
export const GET_MAIN_MARKETS_SUCCESS = 'GET_MAIN_MARKETS_SUCCESS';

export const CHANGE_SELECTED_MARKET = 'CHANGE_SELECTED_MARKET';

export const GET_ALL_MARKETS_REQUEST = 'GET_ALL_MARKETS_REQUEST';
export const CLEAR_ALL_MARKETS = 'CLEAR_ALL_MARKETS';
export const SET_ALL_MARKETS_SELECTED_EVENT = 'SET_ALL_MARKETS_SELECTED_EVENT';
export const GET_MARKET_GROUPS = 'GET_MARKET_GROUPS';
export const SET_FILTERED_MARKET_GROUPS = 'SET_FILTERED_MARKET_GROUPS';
export const SET_SELECTED_MARKET_GROUP = 'SET_SELECTED_MARKET_GROUP';
export const SET_MARKETS_COLLAPSED = 'SET_MARKETS_COLLAPSED';

export const GET_USER_ACCOUNT_REQUEST = 'GET_USER_ACCOUNT_REQUEST';
export const GET_USER_ACCOUNT_SUCCESS = 'GET_USER_ACCOUNT_SUCCESS';
export const CHANGE_UNREAD_MESSAGE_COUNT = 'CHANGE_UNREAD_MESSAGE_COUNT';

export const MESSAGES_FETCHING_CHANGED = 'messages/fetching/changed';
export const MESSAGES_PAGINATING_CHANGED = 'messages/paginating/changed';
export const MESSAGES_PAGE_CHANGED = 'messages/page/changed';
export const MESSAGES_FETCHED = 'messages/fetched';
export const PRIORITY_MESSAGES_FETCHED = 'messages/priority/fetched';
export const MESSAGES_PAGINATED = 'messages/paginated';
export const MESSAGES_HAS_MORE_CHANGED = 'messages/has-more/changed';
export const MESSAGES_FILTERS_STATUS_CHANGED = 'messages/filters/status/changed';
export const MESSAGES_CLEARED = 'messages/cleared';
export const MESSAGES_MESSAGE_DETAILS_CHANGED = 'messages/message/details/changed';

export const GET_SPORT_TYPES_REQUEST = 'GET_SPORT_TYPES_REQUEST';
export const GET_SPORT_TYPES_SUCCESS = 'GET_SPORT_TYPES_SUCCESS';
export const RESET_SPORT_TYPES = 'RESET_SPORT_TYPES';

export const EVENTS_FETCHING_CHANGED = 'events/fetching/changed';
export const EVENTS_PAGINATING_CHANGED = 'events/paginating/changed';
export const SET_SPORT_REF_ID = 'sport_ref_id/changed';
export const EVENTS_FILTERS_CHANGED = 'events/filters/changed';
export const EVENTS_FILTERS_FETCHING_CHANGED = 'events/filters/fetching/changed';
export const EVENTS_FILTER_CHANGED = 'events/filter/changed';
export const EVENTS_CHANGED = 'events/changed';
export const POPULAR_EVENTS_CHANGED = 'popular-events/changed';
export const EVENTS_PAGINATED = 'events/paginated';
export const EVENTS_PAGE_OFFSET_CHANGED = 'events/page-offset/changed';
export const SET_SPORTS_COMPETITION_TYPE = 'events/competition-type/changed';
export const SET_SPORTS_ESPORTS_TYPE = 'events/e-sports/changed';
export const SET_SPORTS_EVENT_TYPE = 'events/event-type/changed';

export const CHANGE_BET_SLIP_BET_LINES = 'bet-slip/betLines/changed';

export const CHANGE_LOCALE = 'CHANGE_LOCAL';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';
export const CHANGE_THEME = 'CHANGE_THEME';
export const CHANGE_TRANSLATION_MODE = 'CHANGE_TRANSLATION_MODE';

export const CHANGE_BET_SLIP_ACTIVE_TAB = 'bet-slip/tabs/active/changed';
export const CHANGE_BET_SLIP_DISABLED_TABS = 'bet-slip/tabs/disabled/changed';
export const RESET_BET_SLIP_DISABLED_TABS = 'bet-slip/tabs/disabled/reset';
export const CHANGE_BET_SLIP_ODD_CHANGE_DECISION = 'bet-slip/odd-change-decision/changed';
export const ADD_BET_SLIP_BET_LINE = 'bet-slip/bet-lines/added';
export const ADD_TICKET_BET_SLIP = 'bet-slip/tickets/added';
export const DELETE_BET_SLIP_BET_LINE = 'bet-slip/bet-lines/deleted';
export const UPDATE_BET_SLIP_BET_LINES = 'bet-slip/bet-lines/updated';
export const CHANGE_BET_SLIP_BET_LINE_STAKE = 'bet-slip/bet-line/stake/changed';
export const BET_SLIP_STAKES_CHANGED = 'bet-slip/stakes/changed';
export const BET_SLIP_PLACED_TICKET_CHANGED = 'bet-slip/placed-ticket/changed';
export const BET_SLIP_COMBINATIONS_CHANGED = 'bet-slip/combinations/changed';
export const BET_SLIP_COUPON_CHANGED = 'bet-slip/coupon/changed';
export const BET_SLIP_LOADING_CHANGED = 'bet-slip/loading/changed';
export const BET_SLIP_EVENTS_LOADING = 'bet-slip/events/loading';
export const BET_SLIP_EVENTS_LOADED = 'bet-slip/events/loaded';
export const BET_SLIP_SUBMIT_BUTTON_CHANGED = 'bet-slip/submit-button/changed';
export const BET_SLIP_RETRY_COUNTER_CHANGED = 'bet-slip/retry-counter/changed';
export const BET_SLIP_ERROR_TIMEOUT_CHANGED = 'bet-slip/error-timeout/changed';
export const CLEAR_BET_SLIP = 'CLEAR_BET_SLIP';
export const SET_BET_BANCO = 'SET_BET_BANCO';
export const CHANGE_BET_STAKE_LIMITS = 'bet-slip/bet-stake-limits/changed';
export const BET_SLIP_MAX_STAKE_LOADING = 'bet-slip/max-stake/loading';
export const BET_SLIP_REQUEST_ID_CHANGED = 'bet-slip/request-id/changed';

export const GET_EVENTS_BY_NAME_REQUEST = 'GET_EVENTS_BY_NAME_REQUEST';
export const GET_EVENTS_BY_NAME_SUCCESS = 'GET_EVENTS_BY_NAME_SUCCESS';

export const CLEAR_EVENT_RESULT = 'CLEAR_EVENT_RESULT';
export const GET_EVENT_DETAILS_REQUEST = 'GET_EVENT_DETAILS_REQUEST';
export const GET_EVENT_DETAILS_SUCCESS = 'GET_EVENT_DETAILS_SUCCESS';
export const CLEAR_EVENT_DETAILS = 'CLEAR_EVENT_DETAILS';
export const UPDATE_EVENT_DETAILS = 'UPDATE_EVENT_DETAILS';
export const GET_EVENT_DETAILS_FAILED = 'GET_EVENT_DETAILS_FAILED';
export const SET_EVENT_SEARCH_PROPS = 'SET_EVENT_SEARCH_PROPS';
export const SET_SHORTCODE_SEARCH_PROPS = 'SET_SHORTCODE_SEARCH_PROPS';
export const SET_ALL_MARKETS_EVENT_REMOVED = 'all-markets/event/removed';

export const PLACE_BET_REQUEST = 'PLACE_BET_REQUEST';
export const PLACE_BET_FAILED = 'PLACE_BET_FAILED';
export const CLEAR_BET_SLIP_PLACE_ERRORS = 'CLEAR_BET_SLIP_PLACE_ERRORS';

export const GET_TICKETS_REQUEST = 'GET_TICKETS_REQUEST';
export const GET_TICKETS_SUCCESS = 'GET_TICKETS_SUCCESS';
export const TICKET_MODAL_PROPS_CHANGED = 'TICKET_MODAL_PROPS_CHANGED';
export const TICKET_MODAL_PROPS_RESET = 'TICKET_MODAL_PROPS_RESET';
export const CLEAR_TICKETS = 'CLEAR_TICKETS';
export const CLEAR_TICKET = 'CLEAR_TICKET';
export const PAY_WIN_REQUEST = 'PAY_WIN_REQUEST';
export const PAY_WIN_SUCCESS = 'PAY_WIN_SUCCESS';
export const PAY_WIN_FAILED = 'PAY_WIN_FAILED';
export const CANCEL_TICKET_REQUEST = 'CANCEL_TICKET_REQUEST';
export const CANCEL_TICKET_SUCCESS = 'CANCEL_TICKET_SUCCESS';
export const CANCEL_TICKET_FAILED = 'CANCEL_TICKET_FAILED';
export const BARCODE_SCANNED = 'BARCODE_SCANNED';
export const BARCODE_ENTERED = 'BARCODE_ENTERED';
export const ERROR_MODAL_PROPS_CHANGED = 'ERROR_MODAL_CHANGED';
export const ERROR_MODAL_PROPS_RESET = 'ERROR_MODAL_PROPS_RESET';

export const GET_VOUCHERS_REQUEST = 'GET_VOUCHERS_REQUEST';
export const GET_VOUCHERS_SUCCESS = 'GET_VOUCHERS_SUCCESS';
export const SET_VOUCHERS = 'SET_VOUCHERS';
export const CLEAR_VOUCHER = 'CLEAR_VOUCHER';
export const CLEAR_VOUCHERS = 'CLEAR_VOUCHERS';
export const VOUCHER_MODAL_PROPS_CHANGED = 'VOUCHER_MODAL_PROPS_CHANGED';
export const VOUCHER_MODAL_PROPS_RESET = 'VOUCHER_MODAL_PROPS_RESET';
export const CANCEL_VOUCHER_REQUEST = 'CANCEL_VOUCHER_REQUEST';

export const GET_EVENT_RESULTS_REQUEST = 'GET_EVENT_RESULTS_REQUEST';
export const GET_EVENT_RESULTS_SUCCESS = 'GET_EVENT_RESULTS_SUCCESS';

export const CLEAR_CHANGE_PASSWORD = 'CLEAR_CHANGE_PASSWORD';
export const CLEAR_MATCH_RESULTS = 'CLEAR_MATCH_RESULTS';

export const GET_SEASONS_REQUEST = 'GET_SEASONS_REQUEST';
export const GET_SEASONS_SUCCESS = 'GET_SEASONS_SUCCESS';

export const INIT_SOCKET_HANDLER = 'INIT_SOCKET_HANDLER';
export const SET_SOCKET_CONNECTED = 'socket/connected';
export const SET_SOCKET_CONTEXT = 'socket/context/changed';
export const SET_WINDOW_VISIBLE = 'SET_WINDOW_VISIBLE';
export const SET_SOCKET_CONNECTION_COUNTER = 'socket/connection-counter/changed';

export const GET_REPORTS_SET_LOADING = 'GET_REPORTS_SET_LOADING';
export const GET_REPORT_GENERAL_BALANCE = 'GET_REPORT_GENERAL_BALANCE';
export const RESET_REPORT_GENERAL_BALANCE = 'RESET_REPORT_GENERAL_BALANCE';
export const GET_REPORT_SPORT_BOOK = 'GET_REPORT_SPORT_BOOK';
export const GET_REPORT_WEEKLY_BALANCE = 'GET_REPORT_WEEKLY_BALANCE';
export const GET_REPORT_TERMINALS_BALANCE = 'GET_REPORT_TERMINALS_BALANCE';
export const SET_CASHIER_PAYMENTS_LOADING = 'GET_REPORTS_LIMIT_DEBT_LOADING';
export const SET_CASHIER_PAYMENTS = 'SET_CASHIER_PAYMENTS';

// Increase Reports
export const INCREASE_REPORTS_FETCHED = 'increase-reports/fetched';
export const INCREASE_REPORTS_PAGINATED = 'increase-reports/paginated';
export const INCREASE_REPORTS_CLEARED = 'increase-reports/cleared';
export const INCREASE_REPORTS_FETCHING_CHANGED = 'increase-reports/fetching/changed';
export const INCREASE_REPORTS_PAGINATING_CHANGED = 'increase-reports/paginating/changed';
export const INCREASE_REPORTS_FILTERS_DATES_CHANGED = 'increase-reports/filters/dates/changed';
export const INCREASE_REPORTS_FILTERS_STATUS_CHANGED = 'increase-reports/filters/status/changed';
export const INCREASE_REPORTS_PAGE_CHANGED = 'increase-reports/page/changed';
export const INCREASE_REPORTS_HAS_MORE_CHANGED = 'increase-reports/has-more/changed';

export const INCREASE_REPORT_MODAL_PROPS_CHANGED = 'increase-report/modal/props/changed';
export const INCREASE_CREDIT_MODAL_PROPS_CHANGED = 'increase-credit/modal/props/changed';
export const INCREASE_CREDIT_MODAL_PROPS_CLEARED = 'increase-credit/modal/props/cleared';
export const ALL_DEVICES_MODAL_PROPS_CHANGED = 'all-devices/modal/props/changed';
export const MESSAGE_MODAL_PROPS_CHANGED = 'messages/modal/props/changed';

export const PRODUCER_STATUSES_CHANGED = 'producer-statuses/changed';

// Global
export const APP_VERSION_CHANGED = 'global/app-version/changed';
export const DEVICE_STATUS_CHANGED = 'global/device-status/changed';

// Favorites
export const FAVORITES_EVENTS_RECEIVED = 'favorites/events/received';
export const FAVORITES_EVENTS_TYPE_CHANGED = 'favorites/events-type/changed';
export const FAVORITES_LEAGUES_CHANGED = 'favorites/leagues/changed';

export const TERMINALS_LIST_CHANGED = 'terminals/list/changed';
export const TERMINALS_FETCHING_CHANGED = 'terminals/fetching/changed';

// Translations
export const TRANSLATIONS_LIST_CHANGED = 'translations/list/changed';
export const TRANSLATIONS_KEYS_CHANGED = 'translations/keys/changed';

// Outrights
export const OUTRIGHTS_CHANGED = 'outrights/changed';
export const OUTRIGHTS_PAGINATED = 'outrights/paginated';
export const OUTRIGHTS_CLEARED = 'outrights/cleared';
